import React from 'react';
import { Button, Box } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const ExpandMapButton = ({ expanded, onToggle }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 16,
        right: 16,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        height: 40, // altura del contenedor
      }}
    >
      <Button
        variant="contained"
        color="inherit"
        onClick={onToggle}
        sx={{
          width: 64, // ancho fijo
          height: 40, // mismo alto que el contenedor
          minWidth: 'unset', // elimina el min-width predeterminado de MUI
          backgroundColor: '#ffffff',
          '&:hover': { backgroundColor: '#f0f0f0' },
        }}
      >
        {expanded ? (
          <ChevronLeftIcon fontSize="large" />
        ) : (
          <ChevronRightIcon fontSize="large" />
        )}
      </Button>
    </Box>
  );
};

export default ExpandMapButton;
